import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_API_URL } from "../utils/constants";

const LearnersReportSlice = createSlice({
    name: "LearnersReport",
    initialState: {
        loader: false,
        error: null,
        success: null,
        categoryPoints: { totalPoints: 0, completedCourses: 0 },
        foundationStatus: { isFoundationCompleted: false, totalMandatory: 0, completedMandatory: 0 },
        topLearners: []
    },
    reducers: {
        setLoader: (state, action) => { state.loader = action.payload; },
        setError: (state, action) => { state.error = action.payload; },
        setSuccess: (state, action) => { state.success = action.payload; },
        resetStatus: (state) => { state.error = null; state.success = null; },
        setCategoryPoints: (state, action) => { state.categoryPoints = action.payload; },
        setFoundationStatus: (state, action) => { state.foundationStatus = action.payload; },
        setTopLearners: (state, action) => { state.topLearners = action.payload; }
    }
});

export const { setLoader, setError, setSuccess, resetStatus, setCategoryPoints, setFoundationStatus, setTopLearners } = LearnersReportSlice.actions;
export default LearnersReportSlice.reducer;

// Upload learners report
export function uploadLearnersReport(file) {
    return (dispatch) => {
        dispatch(setLoader(true));
        dispatch(resetStatus());
        const formData = new FormData();
        formData.append("file", file);

        axios.post(`${BASE_API_URL}/upload-learners-report`, formData, {
            headers: { Authorization: localStorage.getItem("token"), "Content-Type": "multipart/form-data" },
        })
            .then(res => { dispatch(setLoader(false)); dispatch(setSuccess(res.data.message)); })
            .catch(err => { dispatch(setLoader(false)); dispatch(setError(err.response?.data?.message || "Upload failed")); });
    };
}

// Get category points
export function getCategoryPoints(enterpriseId, category) {
    return (dispatch) => {
        dispatch(setLoader(true));
        axios.post(`${BASE_API_URL}/getCategoryPoints`, { enterpriseId, category }, {
            headers: { Authorization: localStorage.getItem("token"), "Content-Type": "application/json" }
        })
            .then(res => { dispatch(setCategoryPoints(res.data)); dispatch(setLoader(false)); })
            .catch(() => { dispatch(setError("Failed to load category points")); dispatch(setLoader(false)); });
    };
}

// Get foundation status
export function fetchFoundationStatus(enterpriseId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        axios.post(`${BASE_API_URL}/getFoundationStatus`, { enterpriseId }, {
            headers: { Authorization: localStorage.getItem("token") }
        })
            .then(res => { dispatch(setFoundationStatus(res.data)); dispatch(setLoader(false)); })
            .catch(() => { dispatch(setError("Failed to fetch Foundation status")); dispatch(setLoader(false)); });
    };
}

// Get Top 10 Learners
export function fetchTopLearners() {
    return (dispatch) => {
        dispatch(setLoader(true));

        axios.get(`${BASE_API_URL}/getTopLearners`, {
            headers: { Authorization: localStorage.getItem("token") }
        })
            .then(res => {
                dispatch(setTopLearners(res.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setError("Failed to fetch top learners"));
                dispatch(setLoader(false));
            });
    };
}
